@import '../../../../style/lib/scss';
@import '../../../../style/src/grid-system/variables';
@import '../../../../style/src/grid-system/mixins';
@import '../../../../style/src/typography/mixins';

:host {
	@include zds-typography('body');

	color: var(--zds-navigation-color);
	display: block;
	overflow: visible;

	// Internal CSS variables, used in zds-navigation-logo
	--zds-navigation-main-bar-inset-x: calc(var(--zds-grid-gutter-x) / 2);
	--zds-navigation-main-bar-inset-y: var(--zds-space-4);

	@include zds-media-breakpoint-up('md') {
		--zds-navigation-main-bar-inset-y: var(--zds-space-6);
	}
}

::slotted(*) {
	min-width: 0; // Prevent slotted elements overflowing flex container
}

::slotted(zds-navigation-body) {
	grid-column-start: 1;
	grid-row-start: 1;
}

.zds-navigation {
	height: auto;
	overflow: visible;
	position: relative;
	width: 100%;
	z-index: 1100;

	&--storybook {
		width: 100%;
	}

	/* Shared */

	&__bar {
		display: flex;
		flex-direction: column;
	}

	&__main-bar,
	&__body-content,
	&__super-bar-wrapper-content {
		@include make-container;

		@each $breakpoint, $width in $zds-breakpoints {
			@include make-container-breakpoint($breakpoint, $width);
		}

		// Remove the max width for LG viewports
		@include zds-media-breakpoint-down('lg') {
			max-width: 100%;
		}
	}

	&__main-bar-wrapper,
	&__body-wrapper {
		background: var(--zds-navigation-background);
	}

	/* Super navigation bar */

	&__super-bar-wrapper {
		--zds-link-color: var(--zds-super-navigation-link-color);
		--zds-link-color-hover: var(--zds-super-navigation-link-color-hover);
		--zds-link-color-visited: var(--zds-super-navigation-link-color);

		background: white; // To show colours with opacity nicely (e.g. subtle colours)
		display: none;
		font-size: var(--zds-super-navigation-font-size);
		order: 0; // Display super-bar above main-bar, while the tab navigation order is reversed

		@include zds-media-breakpoint-up('md') {
			display: initial;
		}
	}

	&__super-bar {
		background: var(--zds-super-navigation-background);
	}

	&__super-bar-wrapper-content {
		display: flex;
		gap: var(--zds-space-6);
		justify-content: flex-start;
		padding-bottom: var(--zds-space-3);
		padding-top: var(--zds-space-3);

		&--full-width {
			max-width: 100%;
		}

		@include zds-media-breakpoint-up('md') {
			gap: var(--zds-space-12);
			justify-content: flex-end;
		}
	}

	/* Main navigation bar */

	&__main-bar-wrapper {
		order: 1;
	}

	&__main-bar {
		padding: var(--zds-navigation-main-bar-inset-y) var(--zds-navigation-main-bar-inset-x);

		&--full-width {
			max-width: 100%;
		}

		::slotted([slot='link']) {
			margin-left: var(--zds-space-6);
		}
	}

	&__skip-button-wrapper {
		margin-bottom: var(--zds-space-4);

		&:not(:focus-within) {
			// As recommended by webaim.org: https://webaim.org/techniques/css/invisiblecontent/
			// We skip the height and width, which are rather unnecessary, to avoid issues with border-radius/padding calculation
			left: -10000px;
			overflow: hidden;
			position: absolute;
			top: auto;
		}
	}

	&__main-bar-content {
		align-items: center;
		display: flex;
	}

	/* Navigation body background */

	&__body-background {
		background: var(--zds-navigation-background);
		height: 0;
		left: 0;
		position: absolute;
		right: 0;
		transition: height 400ms var(--zds-transition-type-ease-in);

		@include zds-media-breakpoint-down('sm') {
			transition-duration: 300ms;
		}

		&--opened {
			transition: height 500ms var(--zds-transition-type-ease-out);

			@include zds-media-breakpoint-down('sm') {
				transition-duration: 400ms;
			}
		}
	}
}
